import {useEffect, useState, useRef} from 'react'
import { useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Tag} from 'antd';
import {getAll, drop} from '../../../../apis/ConceptoApi';
import {clases} from '@app/constants/tipoConcepto';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Conceptos</span>
      </>
    ),
}];

const TipoConceptoPage = () => {
    let navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setobjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const columns = [
      {
        title: 'Clave',
        dataIndex: 'clave',
        key: 'clave',
      },
      {
        title: 'Descripcion',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Tipo de Concepto',
        dataIndex: 'tipo_concepto',
        key: 'tipo_concepto',
        render: (item) => {
          return item?.descripcion || '-';
        }
      },
      {
        title: 'Concepto SAT',
        dataIndex: 'concepto_sat',
        key: 'concepto_sat',
      },
      {
        title: 'Imprimir',
        dataIndex: 'imprimir',
        key: 'imprimir',
        render: (item, object)=> {
          if(item == true){
              return  <Tag color="green">Sí</Tag>;
          }else{
              return  <Tag color="red">No</Tag>;
          }
        }
      },
      {
        title: 'Tiene Formula',
        dataIndex: 'tiene_formula',
        key: 'tiene_formula',
        render: (item, object)=> {
          if(item == true){
              return  <Tag color="green">Sí</Tag>;
          }else{
              return  <Tag color="red">No</Tag>;
          }
        }
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
              <Button type='primary' size='small' danger onClick={()=>{
                  deleteConfirm(object);
              }}>Eliminar</Button>
              <Button type='primary' size='small' onClick={()=>{
                  openDetails(object);
              }}>Editar</Button>
              {
                object.tiene_formula && 
                <Button color="default" variant="filled" size='small' onClick={()=>{goToFormulas(object);}}>Formulas</Button>              
              }
              {
                object.tipo_concepto.clase == 3 && 
                <Button color="default" variant="filled" size='small' onClick={()=>{goToAcomulados(object);}}>
                  Acumulados</Button>
              }
          </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setobjectSelected(object);
    }

    const goToAcomulados = async (object)=>{
      return navigate("../concepto_acomulados/" + object.id);
    }

    const goToFormulas = async (object)=>{
      return navigate("../formulas/" + object.id);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el concepto?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡El concepto ha sido eliminadó!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setobjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return <PageApp routes={routes} 
      title={'Conceptos'} 
      cardTitle='Lista de conceptos'
      extraCard={[
        <Button type="primary" onClick={btnClick}>
          Agregar Concepto
      </Button>
      ]}>
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              items.length == 0 ? <Empty />:
              <Table dataSource={items} columns={columns} />
            }
          </>
      }
      {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Concepto"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Concepto"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default TipoConceptoPage;